import { combineReducers } from "redux";
import { IAuthState, authReducer } from "../features/auth/redux/auth.reducer";
import { ICategoryDto } from "../features/categories/interface/category.dto";
import { categoriesReducer } from "../features/categories/redux";
import { countriesReducer } from "../features/countries/redux";
import { dataFieldsReducer } from "../features/data-fields/redux/";
import {
    globalsReducer,
    IGloablsState,
} from "../features/globals/redux/globals.reducer";
import {
    IListSearchState,
    listSearchReducer,
} from "../features/list-search/redux/list-search.reducer";
import { naicsCodesReducer } from "../features/naics-codes/redux";
import { sicCodesReducer } from "../features/sic-codes/redux";
import { statesReducer } from "../features/states/redux";
import { ICodeNameDto } from "../interface/dto/code-name.dto";
import { IListItem } from "../interface/list-item";
import {
    IChangeLogTableState,
    changeLogReducer,
} from "../pages/change-log/redux/change-log.reducer";
import {
    IDataBrowserListState,
    dataBrowserListReducer,
} from "../pages/data-browser/redux/lists.reducer";
import { IFaqSectionDto } from "../pages/faq/interface/dto/faq.dto";
import { faqReducer } from "../pages/faq/redux";
import { homeReducer, IHomeState } from "../pages/home/redux/home.reducer";
import {
    IListBuilderPageState,
    listBuilderPageReducer,
} from "../pages/list-builder-form/redux/list-builder-form-page.reducer";
import {
    IListBuilderTablePageState,
    listBuilderTablePageReducer,
} from "../pages/list-builder-table/redux/list-builder-table-page.reducer";
import {
    IListPageState,
    listPageReducer,
} from "../pages/list-page/redux/list-page.reducer";
import {
    ITrackedListsState,
    trackedListsReducer,
} from "../pages/tracked-lists/redux/tracked-lists.reducer";
import {
    IUserPreferencesPageState,
    userPreferencesPageReducer,
} from "../pages/user-preferences/redux/user-preferences.reducer";
import { IIGSEState } from "../shared/igse-redux/igse-state";

export interface IRootState {
    listSearch: IListSearchState;
    auth: IAuthState;
    home: IHomeState;
    global: IGloablsState;
    listPage: IListPageState;
    sicCodes: IIGSEState<Array<ICodeNameDto>>;
    naicsCodes: IIGSEState<Array<ICodeNameDto>>;
    dataFields: IIGSEState<Array<string>>;
    countries: IIGSEState<Array<IListItem>>;
    categories: IIGSEState<Array<ICategoryDto>>;
    dataBrowserList: IDataBrowserListState;
    userPreferences: IUserPreferencesPageState;
    trackedList: ITrackedListsState;
    states: IIGSEState<Array<string>>;
    faq: IIGSEState<Array<IFaqSectionDto>>;
    listBuilder: IListBuilderPageState;
    listBuilderTable: IListBuilderTablePageState;
    changeLog: IChangeLogTableState;
}

const rootReducer = combineReducers({
    listSearch: listSearchReducer,
    auth: authReducer,
    home: homeReducer,
    global: globalsReducer,
    listPage: listPageReducer,
    sicCodes: sicCodesReducer,
    naicsCodes: naicsCodesReducer,
    dataFields: dataFieldsReducer,
    countries: countriesReducer,
    categories: categoriesReducer,
    dataBrowserList: dataBrowserListReducer,
    userPreferences: userPreferencesPageReducer,
    trackedList: trackedListsReducer,
    states: statesReducer,
    listBuilder: listBuilderPageReducer,
    listBuilderTable: listBuilderTablePageReducer,
    faq: faqReducer,
    changeLog: changeLogReducer,
});

export default rootReducer;
